import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { AdminEQueryEscalation } from '../models/admin-e-query-escalation';
import { MdlDialogService, IMdlCustomDialogConfiguration } from '@angular-mdl/core';
import { DeleteEscalationDialogComponent, DELETE_ESCALATION_TOKEN } from './delete-escalation-dialog/delete-escalation-dialog.component';

@Component({
    selector: 'escalation-removal-button-ag-renderer',
    template: require('./escalation-removal-button-ag-renderer.component.html'),
    styles: [require('./escalation-removal-button-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscalationRemovalButtonAgRenderer implements AgRendererComponent {
    private escalation: AdminEQueryEscalation;

    constructor(private readonly dialogService: MdlDialogService) {
    }

    public agInit({ data }: { data: AdminEQueryEscalation }) {
        this.escalation = data;
    }

    public refresh(): boolean {
        return false;
    }

    public onRemove() {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: DeleteEscalationDialogComponent,
            isModal: true,
            clickOutsideToClose: true,
            providers: [
                { provide: DELETE_ESCALATION_TOKEN, useValue: this.escalation },
            ],
        };
        this.dialogService.showCustomDialog(configDialog);
    }
}
